import { useAuth0 } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { getEnv } from '@/lib/utils/common/getEnv';
import { getJwtUserContext } from '@/lib/utils/common/getJwtUserContext';

export function useDatadogUserTracking() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((token) => {
        const payload = getJwtUserContext(token);
        datadogRum.setUser({
          id: payload.userId,
          org_id: payload.organizationId,
          org_name: payload.organizationName,
        });
        datadogRum.setGlobalContext({
          org_id: payload.organizationId,
          org_name: payload.organizationName,
          namespace: getEnv().namespace,
        });
      });
    } else {
      // Clear user context when logged out
      datadogRum.clearUser();
    }
  }, [isAuthenticated, getAccessTokenSilently]);
}
